module.exports = __webpack_public_path__ + "img/bank_bg.3c1f9266.png";